import { render, staticRenderFns } from "./IMRequest.vue?vue&type=template&id=a3b9e438&lang=pug"
import script from "./IMRequest.vue?vue&type=script&lang=js"
export * from "./IMRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports